module.exports = __webpack_public_path__ + "03_long_black.d22e05a9.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/daughter/layer5/03_long_black.png
// module id = 5Op1
// module chunks = 0